import { getLogger } from '../base/logging/functions';

export default getLogger('feature/virtual-background');
